/**
 * Scheduled-app kind strings.
 *
 * ux-services replaced the fixed `ScheduledAppKind` enum with a registry plus pattern
 * validation (`^[a-z][a-z0-9_]+$`), so the generated SDK no longer exports a `Kind`
 * enum to reference. Kinds are plain strings now, and the values live here so there is
 * a single place to update as the registry grows — mirroring the Go side, which already
 * keeps these in `bff/constants/scheduled-apps.go` and
 * `bff/domains/scheduled-apps/helpers.go`.
 *
 * Values are transcribed from `services/front/types/app_kinds.go` in the ux-services
 * version immediately before its deletion (v0.0.0-20260807002318-64da275ad286), so they
 * match the kinds the registry was seeded with.
 */
export const ScheduledAppKind = {
  BuildingShutdown: 'building_shutdown',
  // Matches bff/constants/scheduled-apps.go AppMpcCompressorSequencing.
  MpcCompressorSequencing: 'mpc_compressor_sequencing',
  PredictiveDryingControl: 'predictive_drying_control',
  ThermalLoadShifting: 'thermal_load_shifting',
} as const;

/**
 * A scheduled-app kind as sent to / received from ux-services.
 *
 * Deliberately `string` rather than a union of the values above: the registry accepts
 * any kind matching the pattern, so a closed union would wrongly reject kinds this UI
 * simply hasn't been taught about yet.
 */
export type ScheduledAppKindValue = string;
